export default __webpack_public_path__ + "static/media/return-received-at-pdo.d4df9ef5.svg";